export const KNOWLEDGE_BASE_URL = {
  AUCTION_TIMEOUT: 'https://knowledge-base.yieldbird.com/prebid-stack/timeouts',
}
